import { IRollupPrimeProjectsTotals, IRollupSubProjectsTotals } from './rollups.interface';

export const emptyTotals = {
  current_budget: 0,
  contracts: 0,
  total_committed: 0,
  actuals: 0,
  forecasts_to_complete: 0,
  complete: 0,
  total_committed_vs_current_budget: 0,
  actuals_vs_total_committed: 0,
  total_invoiced: 0,
  forecast_modifications: 0,
};

export const emptyGCLineItemTotals = {
  current_budget: 0,
  prime_contract: 0,
  anticipated_income: 0,
  over_under: 0,
  committed_costs: 0,
  anticipated_costs: 0,
  under_over: 0,
  anticipated_fee: 0,
};

export const emptyPrimeProjectTotals: IRollupPrimeProjectsTotals = {
  current_budget: 0,
  prime_contract: 0,
  anticipated_income: 0,
  committed_costs: 0,
  anticipated_costs: 0,
  anticipated_fee: 0,
  over_under: 0,
  under_over: 0,
};

export const emptySubProjectTotals: IRollupSubProjectsTotals = {
  original_subcontract: 0,
  approved_scos: 0,
  pending_scos: 0,
  current_subcontract: 0,
  total_invoiced: 0,
  paid_invoices: 0,
  left_to_invoice: 0,
};
